import { render, staticRenderFns } from "./rewardsForm.vue?vue&type=template&id=4b5fe6f2"
import script from "./rewardsForm.vue?vue&type=script&lang=js"
export * from "./rewardsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports